import { Tooltip } from '../ui/Tooltip';

const CURRENCY_NOTE =
  'Prices sourced from the Azure Retail Prices API (UK South, GBP native). ' +
  'Microsoft fixes the monthly GBP rate using London closing spot rates from ' +
  'the final business days of the prior month.';

/**
 * A subtle ⓘ icon that, on hover/tap, explains where the GBP prices come from.
 * Place it immediately after a £ cost figure.
 */
export function CurrencyTooltip() {
  return (
    <Tooltip content={CURRENCY_NOTE} side="top">
      <span
        className="inline-flex items-center justify-center w-[14px] h-[14px] rounded-full
                   text-[10px] cursor-help transition-colors
                   select-none align-middle ml-1 shrink-0"
        style={{ color: 'var(--text-tertiary)', border: '1px solid var(--outline-variant)' }}
        aria-label="Currency note"
        role="img"
      >
        ⓘ
      </span>
    </Tooltip>
  );
}
